import {HttpModelConverter} from "../../../../../../core/converter/httpModel.converter";
import {PaymentRequestMovementModel} from "./paymentRequestMovement.model";
import {Injectable} from "@angular/core";
import {
    PaymentRequestSummaryConverter
} from "../../../api/entity/converter/paymentRequestSummary.converter";
import {
    AccountingMovementSummaryConverter
} from "../../../../../../accounting/movement/api/entity/converter/accountingMovementSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class PaymentRequestMovementConverter extends HttpModelConverter<PaymentRequestMovementModel> {

    constructor(private p: PaymentRequestSummaryConverter,
                private m: AccountingMovementSummaryConverter) {
        super();
    }

    protected createInstance(): PaymentRequestMovementModel {
        return new PaymentRequestMovementModel();
    }

    protected enrichObject(result: PaymentRequestMovementModel, src: PaymentRequestMovementModel) {
        result.accountingMovement = this.m.convert(src.accountingMovement);
        result.paymentRequest = this.p.convert(src.paymentRequest);
    }
}